
var CgProduct = {

    init: function()
    {

        var me = this;
        me.initTabs();
        me.initSimulation();
        me.initLowStockMessage();
        me.initRelatedProducts();
        me.initSlider();
        me.initFloatingATC();


        // $("#floating_atc .product-form__submit").on("click", function(e){
        //     e.preventDefault();
        //     $(".product__info-container .prod-form-wrap form [type='submit']").click();
        //     return false;
        // });

    },


    initTabs: function()
    {

        var to = null;

        $(".cg-product-tabs .tab-link").on("click", function(e){

            e.preventDefault();
            clearTimeout(to);
            var elem = $(this);
            var target = $(".tab-wrap " + elem.attr("href"));

            if(elem.hasClass("active")){
                elem.removeClass("active");
                target.removeClass("active");
                target.removeClass("animated");
            }else{
                elem.addClass("active");
                target.addClass("active");
                to = setTimeout(function(){
                    target.addClass("animated");
                }, 800);
            }

        });


        var mq = window.matchMedia('(max-width: 991px)');
        if(mq.matches){
            
            $(".cg-product-tabs .tab-4-warp .tab-link").addClass("active");
            $(".cg-product-tabs .tab-4-warp .tab-content").addClass("active").addClass("animated");
        }

    },

    initSlider: function(){

        var slider = $(".product__media-list.contains-media").first();
        if(!slider.length) {
            return;
        }

        var sliderArrowsWrap = slider.closest("slider-component").find(".slider-arrows-wrap").first();
        if(!sliderArrowsWrap.length) {
            return;
        }

        if(slider.hasClass("slick-initialized")) {
            slider.slick("unslick");
        }

        sliderArrowsWrap.empty();

        var prevArrowSrc = sliderArrowsWrap.data("arrow-prev");
        var nextArrowSrc = sliderArrowsWrap.data("arrow-next");


        slider.off('init.cgProductSlider reInit.cgProductSlider afterChange.cgProductSlider');
        slider.on('init.cgProductSlider reInit.cgProductSlider afterChange.cgProductSlider', function(event, slick, currentSlide, nextSlide){
            var i = (currentSlide ? currentSlide : 0) + 1;
            sliderArrowsWrap.find('.slide-num').text(i + '/' + slick.slideCount);
        });


        slider.slick({
            rtl: true,
            slide: ".product__media-item",
            arrows: true,
            appendArrows: sliderArrowsWrap,
            prevArrow: `<button class='arrow arrow-prev'><img class='arrow-img prev' src="${prevArrowSrc}" /></button>`,
            nextArrow: `<div class='slide-num'></div><button class='arrow arrow-next'><img class='arrow-img next' src="${nextArrowSrc}" /></button>`,
            responsive: [
                {
                    breakpoint: 750,
                    settings: "unslick"
                }
            ]
        });

    },

    initLowStockMessage: function(){
        var me = this;
        var inventoryData = JSON.parse($('#product-variant-inventory').html());
        var selectedRadio = $('input[type="radio"][name^="midot carpet dropdown-1"]:checked');
        if (selectedRadio.length > 0) {
            me.updateStockMessage(selectedRadio.val(), inventoryData);
        }

        $(document).on('change', 'input[type="radio"][name^="midot carpet dropdown-1"]', function(e) {
            me.updateStockMessage($(this).val(), inventoryData);
        });

    },

    updateStockMessage: function(optionValue, inventoryData) {
        $(".cg-estimated-delivery").show();
        var variant = inventoryData.variants.find(function(v) {
            return v.option1 === optionValue;
        });
    
        if (variant && variant.inventory_quantity > 0 && variant.inventory_quantity < 10) {
            $('#low-stock-message').text('מהרו, נותרו רק ' + variant.inventory_quantity + ' במלאי!');
        } else {
            $('#low-stock-message').text('');
        }

         if(variant.inventory_quantity == 0) {
            $(".low-stock-message").hide();
            $(".cg-estimated-delivery").addClass('d-none').removeClass("d-flex");
        }else{
            $(".cg-estimated-delivery").removeClass('d-none').addClass("d-flex");
        }


        if(variant.sku) {
            $(".cg-sku-wrap").html(`מק"ט: ${variant.sku}`);
        }
        

    },


    initSimulation: function()
    {

        var defaultURL = 'https://carmelfloor.floori.io/';
        var selectedVariant = $("[data-simulation-sku].selected");

        if(selectedVariant.length) {

            var prod_sku = selectedVariant.attr("data-simulation-sku");
            var newUrl = defaultURL;

            if(prod_sku) {
                newUrl = newUrl + "?sku=" + selectedVariant.attr("data-simulation-sku");
            }
            
            $(".product .simulation-btn").attr("data-simulation", newUrl);

        }else{
            $(".product .simulation-btn").attr("data-simulation", defaultURL);
        }

        $(document).on("click", ".product__info-container .variant-selector label", function(){
            var elem = $(this);
            var prod_sku = elem.attr("data-simulation-sku");
            if(prod_sku) {
                var newUrl = defaultURL + "?sku=" + selectedVariant.attr("data-simulation-sku");
                $(".simulation-btn").attr("data-simulation", newUrl).addClass("has-value");
            }else{
                $(".simulation-btn").attr("data-simulation", defaultURL).removeClass("has-value");
            }
        });

        $(document).on("click", ".product .simulation-btn", function(){
            var rugviewURL = $(this).attr("data-simulation");
            if(rugviewURL) {
                var frame = $(".rugview-frame");
                frame.attr("src", rugviewURL);
                $(".rugview-frame-wrap").addClass("active");
            }
        });

        $(".rugview-frame-wrap .close-btn").on("click", function(){
            $(".rugview-frame-wrap").removeClass("active");
        });

    },


    initRelatedProducts: function(){
        $(".rp-atc-form").on("submit", function(e){
            e.preventDefault();
            var form = $(this)[0];
            var formData = new FormData(form);
            
            fetch('/cart/add', {
                method: 'POST',
                body: formData
            })
            // .then(response => response.json())
            // .then(cart => {
            .then((response) => response.text())
            .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
                for (const selector of selectors) {
                    const targetElement = document.querySelector(selector);
                    const sourceElement = html.querySelector(selector);
                    if (targetElement && sourceElement) {
                        targetElement.replaceWith(sourceElement);
                    }
                }
            });

            return false;
        });
    },

    initFloatingATC: function(){
        var floatingContainer = $("#floating_atc");
        var floatingBtn = $("#floating_atc .floating-btn");
        var floatingInner = floatingBtn.find(".atc-inner");
        var floatingSpinner = floatingBtn.find(".loading__spinner");
        var floatingTextNode = floatingInner.find(".txt").first();
        var floatingIconWrap = floatingInner.find(".ico").first();
        var normalizeLabel = function(value, fallback) {
            var raw = value == null ? "" : String(value);
            var decoded = $.trim($("<div>").html(raw).text());
            return decoded || fallback || "";
        };
        var defaultLabel = normalizeLabel(
            window.variantStrings && window.variantStrings.addToCart,
            $.trim(floatingTextNode.text())
        );
        var buttonObserver = null;
        var observedNode = null;
        var visibilityObserver = null;
        var currentVisibilityTarget = null;

        var findOriginalBtn = function() {
            return $(".prod-form-wrap .product-form__submit").first();
        };

        var isMobileViewport = function() {
            return window.matchMedia("(max-width: 991px)").matches;
        };

        var setFloatingHiddenByMainButton = function(hidden) {
            floatingContainer.toggleClass("is-hidden-by-main-atc", !!hidden);
        };

        var updateFloatingVisibilityByRect = function(targetBtn) {
            if (!targetBtn || !targetBtn.length || !isMobileViewport()) {
                setFloatingHiddenByMainButton(false);
                return;
            }

            var rect = targetBtn[0].getBoundingClientRect();
            var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
            var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
            var isVisible =
                rect.bottom > 0 &&
                rect.right > 0 &&
                rect.top < viewportHeight &&
                rect.left < viewportWidth;

            setFloatingHiddenByMainButton(isVisible);
        };

        var bindVisibilityTracking = function(targetBtn) {
            $(window).off("scroll.cgFloatingATCVisibility resize.cgFloatingATCVisibility orientationchange.cgFloatingATCVisibility");
            if (visibilityObserver) {
                visibilityObserver.disconnect();
                visibilityObserver = null;
            }

            if (!targetBtn || !targetBtn.length) {
                currentVisibilityTarget = null;
                setFloatingHiddenByMainButton(false);
                return;
            }

            currentVisibilityTarget = targetBtn;

            if ("IntersectionObserver" in window) {
                visibilityObserver = new IntersectionObserver(
                    function(entries) {
                        var entry = entries[0];
                        if (!isMobileViewport()) {
                            setFloatingHiddenByMainButton(false);
                            return;
                        }
                        setFloatingHiddenByMainButton(entry.isIntersecting);
                    },
                    { root: null, threshold: 0.02 }
                );
                visibilityObserver.observe(targetBtn[0]);
                return;
            }

            var fallbackHandler = function() {
                updateFloatingVisibilityByRect(currentVisibilityTarget);
            };
            $(window).on("scroll.cgFloatingATCVisibility resize.cgFloatingATCVisibility orientationchange.cgFloatingATCVisibility", fallbackHandler);
            fallbackHandler();
        };

        var syncFloatingState = function() {
            var originalBtn = findOriginalBtn();
            var originalInner = originalBtn.find(".atc-inner").first();
            var labelText = "";
            var isDisabled = originalBtn.is(":disabled");

            if (!originalBtn.length) {
                floatingBtn.prop("disabled", true).removeClass("loading");
                floatingSpinner.addClass("hidden");
                if (floatingTextNode.length) {
                    floatingTextNode.text(defaultLabel);
                } else if (!$.trim(floatingInner.text())) {
                    floatingInner.text(defaultLabel);
                }
                return null;
            }

            if (originalInner.length) {
                var originalTxt = originalInner.find(".txt").first();

                if (originalTxt.length) {
                    labelText = $.trim(originalTxt.text());
                } else {
                    labelText = $.trim(originalInner.text());
                }
            }

            // Keep floating design stable: only change label for disabled states.
            if (isDisabled) {
                var disabledLabel = normalizeLabel(
                    labelText || (window.variantStrings && (window.variantStrings.soldOut || window.variantStrings.unavailable)),
                    defaultLabel
                );
                if (floatingTextNode.length) {
                    floatingTextNode.text(disabledLabel);
                } else {
                    floatingInner.text(disabledLabel);
                }
                floatingIconWrap.addClass("d-none");
            } else {
                if (floatingTextNode.length) {
                    floatingTextNode.text(defaultLabel);
                } else {
                    floatingInner.text(defaultLabel);
                }
                floatingIconWrap.removeClass("d-none");
            }

            floatingBtn.prop("disabled", isDisabled);

            if (originalBtn.hasClass("loading")) {
                floatingBtn.addClass("loading");
                floatingSpinner.removeClass("hidden");
            } else {
                floatingBtn.removeClass("loading");
                floatingSpinner.addClass("hidden");
            }

            return originalBtn;
        };

        var observeCurrentButton = function() {
            var originalBtn = syncFloatingState();
            if (!originalBtn || !originalBtn.length) {
                bindVisibilityTracking(null);
                return;
            }

            if (observedNode === originalBtn[0]) {
                updateFloatingVisibilityByRect(originalBtn);
                return;
            }

            if (buttonObserver) {
                buttonObserver.disconnect();
            }

            observedNode = originalBtn[0];
            buttonObserver = new MutationObserver(function() {
                syncFloatingState();
            });

            buttonObserver.observe(observedNode, {
                attributes: true,
                childList: true,
                subtree: true,
                characterData: true
            });

            bindVisibilityTracking(originalBtn);
        };

        if (floatingBtn.length) {
            observeCurrentButton();

            $(document).on("change", ".prod-form-wrap input[name='id']", function() {
                setTimeout(observeCurrentButton, 0);
            });

            if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined" && PUB_SUB_EVENTS.variantChange) {
                subscribe(PUB_SUB_EVENTS.variantChange, function() {
                    setTimeout(observeCurrentButton, 0);
                });
            }

            $(window).off("resize.cgFloatingATCViewport orientationchange.cgFloatingATCViewport").on("resize.cgFloatingATCViewport orientationchange.cgFloatingATCViewport", function() {
                setTimeout(observeCurrentButton, 0);
            });

            floatingBtn.off("click.cgFloatingATC").on("click.cgFloatingATC", function(e) {
                e.preventDefault();
                var originalBtn = findOriginalBtn();

                if (!originalBtn.length || originalBtn.is(":disabled") || originalBtn.attr("aria-disabled") === "true") {
                    return false;
                }

                var originalForm = originalBtn.closest("form").get(0);

                if (originalForm && typeof originalForm.requestSubmit === "function") {
                    originalForm.requestSubmit(originalBtn.get(0));
                } else {
                    originalBtn.trigger("click");
                }

                return false;
            });
        }
    }


};

$(document).ready(function(){
    CgProduct.init();
});
